module.exports = __webpack_public_path__ + "media/assets/images/claim-places/check-filled-29f45f944b56100dc144a05fcaf4fd08.svg";